export default "__VITE_ASSET__4a88b941__"